import { FETCH_USERS_PAGINATED } from '@/store/actionTypes'

export const SET_GROUP_MEMBERS_SORTING_STATE = 'SET_GROUP_MEMBERS_SORTING_STATE'
export const SET_FILTER_GROUP_MEMBER = 'SET_FILTER_GROUP_MEMBER'
export const RESET_GROUP_MEMBERS_PAGINATION_STATE = 'RESET_GROUP_MEMBERS_PAGINATION_STATE'

export const FETCH_GROUP = 'organizations/users/group/FETCH'
export const FETCH_GROUP_SUCCESS = `${FETCH_GROUP}_SUCCESS`

export const FETCH_GROUP_MEMBERS = `${FETCH_USERS_PAGINATED}_GROUP_MEMBERS`
export const FETCH_GROUP_MEMBERS_SUCCESS = `${FETCH_GROUP_MEMBERS}_SUCCESS`
